import { useEffect, useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from '@/lib/queryClient';
import { useAuth } from './AuthContext';
import { SharesProvider } from './SharesContext';

function SessionCache({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  useEffect(() => () => queryClient.clear(), [queryClient]);

  return (
    <QueryClientProvider client={queryClient}>
      <SharesProvider>{children}</SharesProvider>
    </QueryClientProvider>
  );
}

export function UserSessionProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  // Remount all account state together; late responses retain only the old cache.
  return <SessionCache key={user?.id ?? 'anonymous'}>{children}</SessionCache>;
}
